import {$http,cookies,sessionStore,user, http, util} from '@utils'
import queryString from 'query-string'
import { Base64 } from 'js-base64'
import {default as api,portalApi} from '@utils/api'

/**
 * @history:
 * * @date 2019/11/29 10:05
 * * @desc 新增：增加是否拦截参数默认不拦截
 * * @author 施宜
 * * -------------------------------------------------------
 *
 * @param ifIntercept {boolean} default: false 请求是否拦截
 * @return {Promise<null|*>}
 */
async function getUserInfo(ifIntercept=false){
  if(!user.id) {
    return null;
  }
  const param = JSON.stringify({
    id:user.id
  })

  // 判断http类型
  const httpRequest = ifIntercept ? $http : http

  const response =  await httpRequest.post(portalApi.queryAccountInfoNeedLogin,queryString.stringify({param}),{
    headers: {'Content-Type': 'application/x-www-form-urlencoded'},
    credentials: 'include',withCredentials: true
  });
  if(response && response.data) {
    // 登录状态下非商账号只能访问 安全管理 相关功能， 其余功能都没有权限访问。
    if (util.isNc(response.data) && !top.location.href.includes('/my/safe/')) {
      util.jumptoNcHomepage()
    }
    sessionStore.setItem('userInfo',response.data);
    if(response.data.buzzId) {
      cookies.set('buzzId',response.data.buzzId,{ expires: 1 });
    }
    if(response.data.parentBuzzId) {
      cookies.set('parentBuzzId',response.data.parentBuzzId, { expires: 1 });
    }
    if(response.data.buzzType) {
      cookies.set('buzzType',response.data.buzzType, { expires: 1 });
    }
    if(response.data.buzzCode) {
      cookies.set('buzzCode',response.data.buzzCode, { expires: 1 });
    }
    if(response.data.userId) {
      cookies.set('userId',response.data.userId, { expires: 1 });
    }
    return response.data
  } else {
    return null
  }
}

async function getSecurityConfig() {
  const res = await http.get(`${api.cmsHost}/publish/976/security.json`)
  if (res && res.data && res.data.security) {
    return res.data.security
  } else {
    return {}
  }
}

export default {

  async getUserInfo({commit}){
    const userInfo = await getUserInfo();
    commit('getUserInfo', userInfo)
    return userInfo;
  },
  async getUserInfo2Interceptor({commit},ifIntercept=true){
    const userInfo = await getUserInfo(ifIntercept);
    commit('getUserInfo', userInfo)
    return userInfo;
  },

  async checkPicCode({ commit }, { identity, appCode, appServiceCode, verifyCode, needBase64 = true }) {
    let param = { identity, appCode, appServiceCode, verifyCode }
    if (needBase64) {
      param = {
        identity: Base64.encode(identity),
        appCode: Base64.encode(appCode),
        appServiceCode: Base64.encode(appServiceCode),
        verifyCode: Base64.encode(verifyCode)
      }
    }
    const query = queryString.stringify(param)
    const res = await $http.get(`${api.mainHost}/portal-api/user/checkVcode.do?${query}`);
    return res
  },
  async sendEmail({ commit }, { recipients, type, url}) {
    const param = JSON.stringify({
      serviceCode: 'reg',
      recipients,
      type,
      url,
    })
    const res = await http.post(`${api.mainHost}/portal-api/user/sendEmail.do`, queryString.stringify({ param }),
    {
      headers: {
        'content-Type': 'application/x-www-form-urlencoded'
      }
    })
    return res && res.data
  },

  async getSecurityConfig({commit}){
    const securityConfig  = await getSecurityConfig()
    commit('getSecurityConfig', securityConfig)
    return securityConfig
  }
}
